import { useMemo, useState } from "react";
import { SciOutputBox, SciTextArea } from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { translate } from "../lib/translation";

export function TranslationCalc() {
  const [seq, setSeq] = useState("");
  const [frame, setFrame] = useState(0);
  const [stopAtStop, setStopAtStop] = useState(false);

  const result = useMemo(
    () => translate(seq, frame, stopAtStop),
    [seq, frame, stopAtStop],
  );

  return (
    <div className="sci-card rounded-2xl p-6 sm:p-8">
      <SciTextArea
        id="translate-input"
        label={m.translate_input_label()}
        value={seq}
        placeholder={m.translate_input_placeholder()}
        onChange={setSeq}
      />

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-xs text-muted-foreground">
          {m.translate_frame_label()}:
        </span>
        {[0, 1, 2].map((f) => (
          <button
            key={f}
            type="button"
            aria-pressed={frame === f}
            onClick={() => setFrame(f)}
            className={
              frame === f
                ? "sci-result-zone sci-result rounded-md px-3 py-1.5 text-sm font-semibold"
                : "sci-panel rounded-md px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
            }
          >
            +{f + 1}
          </button>
        ))}
        <label className="ml-auto flex items-center gap-2 text-sm text-muted-foreground">
          <input
            type="checkbox"
            checked={stopAtStop}
            onChange={(e) => setStopAtStop(e.target.checked)}
            className="h-4 w-4 accent-[var(--accent-c)]"
          />
          {m.translate_stop_label()}
        </label>
      </div>

      {result.protein ? (
        <>
          <SciOutputBox
            label={m.translate_output_label()}
            value={result.protein}
            testId="translate-output"
          />
          <p className="mt-2 text-xs text-muted-foreground">
            {m.translate_length({
              n: result.protein.replace(/\*/g, "").length,
            })}
          </p>
        </>
      ) : (
        <p className="mt-5 text-sm text-muted-foreground">
          {m.translate_hint_empty()}
        </p>
      )}
    </div>
  );
}
